module.exports = __webpack_public_path__ + "e8b0a8b.woff";